module.exports = __webpack_public_path__ + "img/logo.1da9edd5.png";